<!--
 * @Description  : 平台服务 --- 安招采服务管理
 * @Author       : 王帅
 * @Date         : 2026-07-14 11:25:01
 * @LastEditors  : 王帅
 * @LastEditTime : 2026-07-14 17:25:11
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\platform-services\service-azc.vue
-->
<template>
	<div class="h100 audit">
		<!-- 列表查询页 -->
		<filter-layout @search="doSearch" @reset="doReset" hasHeader>
			<template #header>
				<el-tabs v-model="activeTab" @tab-click="tabChange(activeTab)">
					<el-tab-pane name="company" label="平台会员服务"> </el-tab-pane>
					<el-tab-pane name="user" label="移动认证管理"> </el-tab-pane>
					<el-tab-pane name="skill" label="平台技术服务费（包年）"> </el-tab-pane>
					<el-tab-pane name="records" label="安徽CA办理记录"> </el-tab-pane>
				</el-tabs>
			</template>

			<template #filter>
				<!-- 不同tab 的 form -->
				<template v-if="['company', 'user'].includes(activeTab)">
					<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" :model="searchForm" label-width="110px">
						<el-form-item label="开通单位" prop="payCompanyName">
							<el-input v-model="searchForm.payCompanyName" placeholder="请输入开通单位" clearable></el-input>
						</el-form-item>
						<el-form-item label="服务类型" prop="goodsCode">
							<el-select v-model="searchForm.goodsCode" placeholder="请选择" clearable>
								<el-option value="0" label="新办"></el-option>
								<el-option value="1" label="续费"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="状态" prop="payStatus">
							<el-select v-model="searchForm.payStatus" placeholder="请选择" clearable>
								<el-option v-for="item in statusArr" :key="item.value" :value="item.value" :label="item.label"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="税号" prop="payCompanyCreditcode">
							<el-input v-model="searchForm.payCompanyCreditcode" placeholder="请输入税号" clearable></el-input>
						</el-form-item>
						<el-form-item label="权益使用者" prop="userName" v-if="activeTab == 'user'">
							<el-input v-model="searchForm.userName" placeholder="请输入" clearable></el-input>
						</el-form-item>
						<el-form-item label="开通时间" prop="dateArr" class="w50">
							<el-date-picker
								v-model="searchForm.dateArr"
								type="daterange"
								clearable
								ref="datePicker"
								placeholder="请选择"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								value-format="yyyy-MM-dd"
							></el-date-picker>
						</el-form-item>
						<el-form-item label-width="0">
							<el-button class="btn-blue" type="primary" size="mini" @click="changeDateRange('currentDay')">今日</el-button>
							<el-button class="btn-blue" type="primary" size="mini" @click="changeDateRange('currentMonth')">本月</el-button>
							<el-button class="btn-blue" type="primary" size="mini" @click="changeDateRange('currentYear')">本年</el-button>
						</el-form-item>
					</el-form>
				</template>
				<!-- 平台技术服务费 -->
				<template v-if="activeTab == 'skill'">
					<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" label-width="80px" :model="searchForm">
						<el-form-item label="开通单位" prop="payCompanyName">
							<el-input placeholder="请输入" clearable v-model="searchForm.payCompanyName"> </el-input>
						</el-form-item>
						<el-form-item label="税号" prop="payCompanyCreditcode">
							<el-input placeholder="请输入" clearable v-model="searchForm.payCompanyCreditcode"> </el-input>
						</el-form-item>
						<el-form-item label="开通时间" prop="dateArr">
							<el-date-picker
								v-model="searchForm.dateArr"
								type="daterange"
								range-separator="-"
								align="center"
								value-format="yyyy-MM-dd"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								clearable
							>
							</el-date-picker>
						</el-form-item>
						<el-form-item label-width="0">
							<el-button class="btn-blue" type="primary" size="mini" @click="changeDateRange('currentDay')">今日</el-button>
							<el-button class="btn-blue" type="primary" size="mini" @click="changeDateRange('currentMonth')">本月</el-button>
							<el-button class="btn-blue" type="primary" size="mini" @click="changeDateRange('currentYear')">本年</el-button>
						</el-form-item>
						<el-form-item label="生效状态" prop="payStatus">
							<el-select v-model="searchForm.payStatus" placeholder="请选择" clearable>
								<el-option v-for="item in skillStatusArr" :key="item.value" :label="item.label" :value="item.value"> </el-option>
							</el-select>
						</el-form-item>
					</el-form>
				</template>
				<!-- 安徽CA办理记录 -->
				<template v-if="activeTab == 'records'">
					<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" :model="recordForm" label-width="120px">
						<el-form-item label="开通单位：" prop="owner">
							<el-input v-model="recordForm.owner" placeholder="请输入" clearable></el-input>
						</el-form-item>
						<el-form-item label="税号：" prop="idNo">
							<el-input v-model="recordForm.idNo" placeholder="请输入" clearable></el-input>
						</el-form-item>

						<el-form-item label="锁类型：" prop="lockType">
							<el-select v-model="recordForm.lockType" clearable>
								<el-option :value="0" label="副锁"></el-option>
								<el-option :value="1" label="主锁"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="证书状态：" prop="cerState">
							<el-select v-model="recordForm.cerState" clearable>
								<el-option :value="0" label="已废除"></el-option>
								<el-option :value="1" label="已发证"></el-option>
								<el-option :value="2" label="已归档"></el-option>
							</el-select>
						</el-form-item>
					</el-form>
				</template>
			</template>

			<template #content>
				<transition name="fade" mode="out-in">
					<tab-company v-if="activeTab == 'company'" :searchForm="searchForm" ref="tabContent" @openDetail="openDetail"></tab-company>
					<tab-user v-if="activeTab == 'user'" :searchForm="searchForm" ref="tabContent" @openDetail="openDetail"></tab-user>
					<tab-skill v-if="activeTab == 'skill'" :searchForm="searchForm" ref="tabContent"></tab-skill>
					<tab-records v-if="activeTab == 'records'" :searchForm="recordForm" ref="tabContent"></tab-records>
				</transition>
			</template>
		</filter-layout>

		<!-- 弹窗 -->
		<detail-dialog :activeTab="activeTab" ref="detailDialog"></detail-dialog>
	</div>
</template>

<script>
import { mapState } from 'vuex'

const tabCompany = () => import('./azc-components/tab-company.vue')
const tabUser = () => import('./azc-components/tab-user.vue')
const tabSkill = () => import('./azc-components/tab-skill.vue')
const tabRecords = () => import('./azc-components/tab-records.vue')
const detailDialog = () => import('./components/mobileCa-detail.vue')

export default {
	name: 'audit-affairs-new',
	components: {
		tabCompany,
		tabUser,
		tabSkill,
		tabRecords,
		detailDialog
	},
	data() {
		return {
			activeTab: 'company',
			//筛选框
			searchForm: {
				payCompanyName: '', //开通公司
				payCompanyCreditcode: '', //税号
				dateArr: [],
				payStartTime: '', //申请开始时间
				payEndTime: '', //申请结束时间
				goodsCode: '', //服务类型
				payStatus: '', //状态
				userName: '' // 权益使用者
			},
			// 记录的表单
			recordForm: {
				owner: '',
				idNo: '',
				cerState: '',
				lockType: ''
			},
		}
	},
	created() {
		// 默认当月
		let startDay = this.$utils.getWhatMonth(new Date(), 0, 'first')
		let endDay = this.$utils.getWhatMonth(new Date(), 0, 'last')
		this.searchForm.dateArr = [this.$utils.toDateString(startDay, 'yyyy-MM-dd'), this.$utils.toDateString(endDay, 'yyyy-MM-dd')]
		this.doSearch()
	},
	methods: {
		// tab切换
		tabChange(val) {
			this.activeTab = val
			this.searchForm = {
				payCompanyName: '', //开通公司
				payCompanyCreditcode: '', //税号
				dateArr: [],
				payStartTime: '', //申请开始时间
				payEndTime: '', //申请结束时间
				goodsCode: '', //服务类型
				payStatus: '', //状态
				userName: '' // 权益使用者
			}
			this.recordForm = {
				owner: '',
				idNo: '',
				cerState: '',
				lockType: ''
			}
			setTimeout(() => {
				// 默认当月
				let startDay = this.$utils.getWhatMonth(new Date(), 0, 'first')
				let endDay = this.$utils.getWhatMonth(new Date(), 0, 'last')
				this.searchForm.dateArr = [this.$utils.toDateString(startDay, 'yyyy-MM-dd'), this.$utils.toDateString(endDay, 'yyyy-MM-dd')]
				this.doSearch()
			}, 100)
		},

		// 搜索
		doSearch() {
			this.$nextTick(() => {
				setTimeout(() => {
					this.$refs.tabContent && this.$refs.tabContent.getData()
				}, 300)
			})
		},

		//筛选框重置
		doReset() {
			this.searchForm = {
				payCompanyName: '', //开通公司
				payCompanyCreditcode: '', //税号
				dateArr: [],
				payStartTime: '', //申请开始时间
				payEndTime: '', //申请结束时间
				goodsCode: '', //服务类型
				payStatus: '', //状态
				userName: '' // 权益使用者
			}
			this.recordForm = {
				owner: '',
				idNo: '',
				cerState: '',
				lockType: ''
			}
			setTimeout(() => {
				this.$refs.tabContent && this.$refs.tabContent.doReset()
			}, 300)
		},

		// 关闭服务弹窗
		openDetail({ type, row }) {
			this.$refs.detailDialog.openDialog(type, row)
		},

		// 快捷按钮选项 改变日期
		changeDateRange(type) {
			// 本日
			let dayStart = this.$utils.getWhatDay(new Date(), 0, 'first')
			let dayEnd = this.$utils.getWhatDay(new Date(), 0, 'last')
			// 本月
			let monthStart = this.$utils.getWhatMonth(new Date(), 0, 'first')
			let monthEnd = this.$utils.getWhatMonth(new Date(), 0, 'last')
			// 本年
			let yearStart = this.$utils.getWhatYear(new Date(), 0, 'first')
			let yearEnd = this.$utils.getWhatYear(new Date(), 0, 'last')
			switch (type) {
				case 'currentDay':
					this.searchForm.dateArr = [this.$utils.toDateString(dayStart, 'yyyy-MM-dd'), this.$utils.toDateString(dayEnd, 'yyyy-MM-dd')]
					break
				case 'currentMonth':
					this.searchForm.dateArr = [this.$utils.toDateString(monthStart, 'yyyy-MM-dd'), this.$utils.toDateString(monthEnd, 'yyyy-MM-dd')]
					break
				case 'currentYear':
					this.searchForm.dateArr = [this.$utils.toDateString(yearStart, 'yyyy-MM-dd'), this.$utils.toDateString(yearEnd, 'yyyy-MM-dd')]
					break
			}
			this.doSearch()
		}
	},
	computed: {
		...mapState('user', { userInfo: (state) => state.userInfo }),

		// 支付状态码表
		statusArr() {
			let arr = [
				{ value: '0', label: '生效中' },
				{ value: '1', label: '已失效' },
				{ value: '2', label: '已关闭' },
				{ value: '3', label: '待生效' }
			]

			if (this.activeTab == 'user') {
				arr.push({ value: '4', label: '待核销' })
			}
			return arr
		},

		// 不同码表展示的文字
		statusText() {
			let text = ''
			let that = this
			return function(type, value) {
				switch (type) {
					// 服务类型
					case 'goodsCode':
						text = value !== '' ? ['新办', '续费'][parseFloat(value)] : ''
						break
					// 状态
					case 'payStatus':
						let item = that.statusArr.find((x) => parseFloat(x.value) === parseFloat(value))
						text = item && item.label ? item.label : ''
						break
				}
				return text
			}
		},

		// 日期选择快捷选项
		pickerOptions() {
			let that = this
			// 本日
			let dayStart = this.$utils.getWhatDay(new Date(), 0, 'first')
			let dayEnd = this.$utils.getWhatDay(new Date(), 0, 'last')
			// 本月
			let monthStart = this.$utils.getWhatMonth(new Date(), 0, 'first')
			let monthEnd = this.$utils.getWhatMonth(new Date(), 0, 'last')
			// 本年
			let yearStart = this.$utils.getWhatYear(new Date(), 0, 'first')
			let yearEnd = this.$utils.getWhatYear(new Date(), 0, 'last')
			return {
				shortcuts: [
					{
						text: '今日',
						onClick(picker) {
							console.log('😍 ~ picker:', picker)
							picker.$emit('pick', [dayStart, dayEnd])
							setTimeout(() => {
								that.doSearch()
							}, 200)
						}
					},
					{
						text: '本月',
						onClick(picker) {
							picker.$emit('pick', [monthStart, monthEnd])
							setTimeout(() => {
								that.doSearch()
							}, 200)
						}
					},
					{
						text: '本年',
						onClick(picker) {
							picker.$emit('pick', [yearStart, yearEnd])
							setTimeout(() => {
								that.doSearch()
							}, 200)
						}
					},
					{
						text: '最近一周',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
							picker.$emit('pick', [start, end])
							setTimeout(() => {
								that.doSearch()
							}, 200)
						}
					},
					{
						text: '最近三个月',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
							picker.$emit('pick', [start, end])
							setTimeout(() => {
								that.doSearch()
							}, 200)
						}
					}
				]
			}
		},

		// skill 生效状态码表
		skillStatusArr() {
			return [
				{
					value: 1,
					label: '生效'
				},
				{
					value: 2,
					label: '待生效'
				},
				{
					value: 3,
					label: '已失效'
				}
			]
		}
	}
}
</script>

<style scoped lang="less">
.audit {
	.searchBox {
		padding-top: 8px;
	}

	/deep/ .more-layout {
		top: 55px;
		right: 370px;
	}

	/deep/ .el-tabs__item {
		// width: 100px;
		height: 32px;
		line-height: 32px;
		text-align: center;
		background: #f0f0f0;
		border-radius: 3px 3px 0px 0px;
		color: #666;
		margin-right: 20px;
		padding: 0 15px !important;

		.el-tabs__header {
			border-bottom: 1px solid #2671cc;
		}
	}

	/deep/ .el-tabs__item.is-active {
		color: #fff;
		background-color: #2671cc !important;
	}

	/deep/ .el-tabs__nav-wrap::after {
		background-color: #2671cc;
		height: 1px;
		z-index: 999;
	}

	/deep/ .el-tabs__active-bar {
		background-color: transparent;
	}

	.auditMsg {
		color: #2671cc;
		cursor: pointer;
	}

	.green,
	.red,
	.orange {
		display: inline-block;
		height: 28px;
		line-height: 28px;
		padding: 0 10px;
		font-size: 12px;
		border-radius: 5px;
	}

	.green {
		background: #e9f6f2;
		border: 1px solid #bff5e5;
		color: #39c098;
	}

	.red {
		background: #feeff0;
		border: 1px solid #fde2e2;
		color: #f56c6c;
	}

	.orange {
		background: #fdf6ec;
		border: 1px solid #faecd8;
		color: #e7a23c;
	}

	.toolbar {
		position: relative;

		.toolbar-right {
			position: absolute;
			right: 0;
			top: 0;
		}
	}

	/deep/ .el-table__header-wrapper {
		tr > th {
			padding: 6px 0 !important;
			height: 50px !important;
		}
	}

	.item {
		position: absolute !important;
		right: -15px;
	}
}

.sHeight {
	padding: 0;
}

.view-ca-dia {
	/deep/ .el-dialog__header {
		background-color: #2671cc;

		span,
		.el-dialog__close {
			color: #fff;
			font-weight: normal;
		}
	}

	.fontWeightBold {
		color: #202020;
		font-size: 16px;
	}

	.left {
		color: #202020;
		font-weight: 600;
	}

	.right {
		color: #666666;
		text-align: right;
	}
}

.audit-company-dialog {
	/deep/ .el-dialog__body {
		max-height: 700px !important;
	}
}

@media screen and (max-height: 900px) {
	/deep/ .el-dialog__body {
		max-height: 560px !important;
	}

	.audit-company-dialog {
		/deep/ .el-dialog__body {
			max-height: 560px !important;
		}
	}
}

@media screen and (max-height: 660px) {
	/deep/ .el-dialog__body {
		max-height: 440px !important;
	}

	.audit-company-dialog {
		/deep/ .el-dialog__body {
			max-height: 440px !important;
		}
	}
}
</style>
